import React from "react";
import { CtaButton } from "../CtaButton";
import { Icon } from "../Icon";
import { SectionHeading } from "../SectionHeading";
import { tools } from "../../data/content";
export function Tools() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-320" data-mp="2hj9rwqoxejf3">
      <div className="mx-auto max-w-4xl" data-id="element-321" data-mp="2dig7w8eltorh">
        <SectionHeading eyebrow="Plus" title={<>Ready-to-Use Educational Tools <em className="text-forest" data-id="element-323" data-mp="28jmush38bzru">Included</em></>} intro="The six volumes are only part of the collection. I've also organized practical resources you can use alongside the main materials." data-id="element-322" data-mp="2dhel56o87dtx" />

        <ul className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-324" data-mp="1yublatcfkt3f">
          {tools.map(t => <li key={t.title} className="flex items-start gap-4 py-5" data-id="element-325" data-mp="1tw1ram2fzyje">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-forest text-white" data-id="element-326" data-mp="1pt52ueq8187j">
                <Icon name={t.icon} className="h-6 w-6" data-id="element-327" data-mp="1kv3i7pd5d0ty" />
              </span>
              <div data-id="element-328" data-mp="1597q3m4yxi2r">
                <h3 className="text-[18px] font-bold text-ink" data-id="element-329" data-mp="158ocghmcpfuj">{t.title}</h3>
                <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-330" data-mp="1a0fzwja7n5gg">{t.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] font-semibold leading-relaxed text-forest" data-id="element-331" data-mp="w6osphjybxnw">
          Instead of creating every resource yourself, you'll receive a collection of tools already prepared for you.
        </p>

        <div className="mt-8" data-id="element-332" data-mp="1szk5tj6ggj3w">
          <CtaButton label="Yes! I want access to the complete system" data-id="element-333" data-mp="1syilsp7goma1" />
        </div>
      </div>
    </section>;
}